import store from '../store'
import moment from 'moment'

export function getUserToken () {
  /**
   * Получает токен пользователя или null, если не найден
   * @return {string|null} токен пользователя или null если не найден
   */
  return localStorage.getItem('user-token')
}

export function isWorker () {
  /**
   * Проверяет является ли пользователь работником
   * @return {boolean} true если пользователь является работником
   */
  return store.state.user.isWorker && localStorage.getItem('isWorker')
}

export function isAuthenticated () {
  /**
   * Проверяет аутентификацию пользователя
   * @return {boolean} true если полльзователь аунтефицирован
   */
  return store.state.user.isAuthenticated && localStorage.getItem('user-token')
}

export function clearUserAuth () {
  /**
   * Очищает данные аутентификации пользователя
   * Удаляет данные из localStorage, cookies и обновляет состояние
   */
  localStorage.removeItem('user-token') // clear obj.users.exclude(user=self.context['request'].user.db_user).first().user.full_nameyour user's token from localstorage
  localStorage.removeItem('isWorker')
  localStorage.removeItem('username')
  localStorage.removeItem('user-uid')
  window.$cookies.remove('userMuctr')
  store.commit('auth/AUTH_LOGOUT')
}

export function checkIsProductionServer () {
  /**
   * Проверяет, запущено ли приложение в production-режиме
   * @return {boolean} true, если окружение production
   */
  return process.env.NODE_ENV === 'production'
}
export function checkIsDevelopmentServer () {
  /**
   * Проверяет, запущено ли приложение в development-режиме
   * @return {boolean} true, если окружение development
   */
  return process.env.NODE_ENV === 'development'
}

export function getUserUid () {
  /**
   * Получает уникальный идентификатор пользователя из localStorage
   * @return {string|null} UID пользователя или null, если не найден
   */
  return localStorage.getItem('user-uid')
}

export function makeProfileUrl (url) {
  /**
   * Формирует URL профиля пользователя, заменяя шаблоны на реальный UID
   * @param {string} url - URL с шаблонами для замены
   * @return {string} URL с подставленным идентификатором пользователя
   */
  return url.replace('<user-uid>', getUserUid()).replace('<uuid:user>', getUserUid()).replace('<user>', getUserUid())
}

export function getDisplay (value, selector) {
  /**
   * Возвращает текстовое отображение для значения из списка выбора
   * @param {any} value - значение для поиска в селекторе
   * @param {Array} selector - массив объектов с полями value и text
   * @return {string|null} текстовое представление значения или null
   */
  if (selector) {
    const res = selector.find((el) => {
      if (el.value === value) {
        return true
      } else {
        return false
      }
    })
    if (res) { return res.text } else { return null }
  } else { return null }
}

export function mapPaginatedResult (from, to) {
  /**
   * Присваивает параметры пагинации к объекту из запроса
   * @param {Object} from - объект с параметрами пагинации (источник)
   * @param {Object} to - объект, в который добавляются параметры пагинации (цель)
   */
  to.next = from.next
  to.prev = from.previous
  to.count = from.count
}

export function checkFieldExist (object, field) {
  /**
   * Проверяет существование поля в объекте
   * @param {Object} object - объект, в котором проводится проверка
   * @param {String} field - проверяемое поле
   * @returns {Boolean} true, если поле существует
   */
  if (object !== Object && object !== Array) { return false }
  return field in object
}

export function checkFieldTrue (object, field) {
  /**
   * Проверяет, что поле существует и имеет истинное значение
   * @param {Object} object - объект, в котором проводится проверка
   * @param {String} field - проверяемое поле
   * @returns {Boolean} true, если поле существует и истинно
   */
  return checkFieldExist(object, field) && object[field]
}

export function getFieldOrEmpty (object, field) {
  /**
   * Возвращает значение поля или пустую строку, если поле отсутствует
   * @param {Object} object - объект, в котором проводится проверка
   * @param {String} field - проверяемое поле
   * @returns {any} значение поля или пустая строка
   */
  if (checkFieldExist(object, field)) { return object[field] }
  return ''
}

export function displayDate (date, minutes = false) {
  /**
   * Форматирует дату для отображения по-русски
   * @param {string|Date} date - строка даты и времени или объект Date
   * @param {Boolean} minutes - выводить ли минуты (по умолчанию false)
   * @returns {String} отформатированная строка даты
   */
  let format = 'DD.MM.YYYY'
  if (minutes) { format += ' HH:mm' }
  return moment(date).format(format)
}

export function getDomain () {
  /**
   * Получает домен для установки cookies
   * @returns {string|null} домен или null
   */
  if (process.env.VUE_APP_COOKIE_DOMAIN !== undefined) {
    return process.env.VUE_APP_COOKIE_DOMAIN
  } else {
    return null
  }
}

export function getWordDeclension (number, one, two, five) {
  /**
   * Склоняет слова по падежам в зависимости от числа
   * @param {number} number - число для определения склонения
   * @param {String} one - форма слова для 1 (один)
   * @param {String} two - форма слова для 2 (два)
   * @param {String} five - форма слова для 5 (пять)
   * @returns {String} слово в правильной форме
   */
  let n = Math.abs(number % 100);
  if (n >= 5 && n <= 20) return five;
  n %= 10;
  if (n === 1) return one;
  if (n >= 2 && n <= 4) return two;
  return five;
}
